import { useCallback, type FunctionComponent } from "react";
import { Icon, Text } from "@smartsuite/react-ui/lib";

import { StyledWrapper, StyledInner } from "./styles";
import type { IconSizes } from "@smartsuite/icons";
import type { OperatorDescriptionKinds } from "../../constanst";
import { GrayColors, TextColorNames } from "@smartsuite/types";

export type UpdateValueType =
  | OperatorDescriptionKinds.REPLACE
  | OperatorDescriptionKinds.CLEAR
  | OperatorDescriptionKinds.APPEND;

interface UpdateValueOptionProps {
  isSelected: boolean;
  isPlaceholder?: boolean;
  type: UpdateValueType;

  onClick?: (type: UpdateValueType) => void;
}

export const UpdateValueOption: FunctionComponent<UpdateValueOptionProps> = ({
  type,
  isPlaceholder = false,
  isSelected,

  onClick,
}) => {
  const handleClick = useCallback(
    (e) => {
      if (!isPlaceholder) {
        e.stopPropagation();
      }
      if (onClick) {
        onClick(type);
      }
    },
    [type],
  );
  const iconName = iconNameList[type];
  const iconSize = iconSizeList[type] as IconSizes;
  return (
    <StyledWrapper
      isPlaceholder={isPlaceholder}
      isSelected={isSelected}
      onClick={handleClick}
    >
      <Icon
        className="type-icon"
        name={iconName}
        size={iconSize}
        color={isSelected ? GrayColors["G-0"] : TextColorNames.primary}
      />
      <StyledInner>
        <Text
          className="update-value-option-title"
          ariaLabel="Selected Changes"
          color={isSelected ? "reverse" : "primary"}
          weight="medium"
        >
          {titles[type]}
        </Text>
        {!isPlaceholder && (
          <Text
            weight="medium"
            size="xs"
            color={isSelected ? "reverse" : "secondary"}
          >
            {descriptions[type]}
          </Text>
        )}
      </StyledInner>
    </StyledWrapper>
  );
};

const iconNameList = {
  replace: "refresh",
  clear: "minus",
  append: "plus",
};

const iconSizeList = {
  replace: "M",
  clear: "S",
  append: "S",
};

// TODO: Add translates
const titles = {
  replace: "Replace Value",
  clear: "Clear Value",
  append: "Append Value",
};

const descriptions = {
  replace: "Replace field value with new",
  clear: "Clear field value",
  append: "Add this value next to the old one",
};
